/**
 * PV Early Access · Gift Tiers
 * Keeps the tier progress in sync with the cart total.
 * - Initial total comes from Liquid (data-cart-total, presentment cents).
 * - Updates on the bubbling `cart:refresh` event on <html> (fired by
 *   pv-early-access-cart.js, the mini-cart drawer and on pageshow). When the
 *   event has no cart total, /cart.js is fetched instead.
 * - Thresholds are in the shop currency; they're converted with
 *   Shopify.currency.rate when the visitor shops in another currency.
 * Display only: never adds gifts to the cart.
 */

(function () {
  'use strict';

  var ROOT = '[data-pv-eagt]';

  function rate() {
    var r = window.Shopify && window.Shopify.currency && parseFloat(window.Shopify.currency.rate);
    return r > 0 ? r : 1;
  }

  function clamp01(n) {
    return Math.max(0, Math.min(1, n));
  }

  function segment(total, from, to) {
    if (to > from) return clamp01((total - from) / (to - from));
    return total >= to ? 1 : 0;
  }

  function setFill(el, value) {
    if (el) el.style.setProperty('--pv-eagt-fill', String(Math.round(value * 1000) / 1000));
  }

  function update(root, totalCents) {
    var total = (Number(totalCents) || 0) / 100;
    var r = rate();
    var tiers = root.querySelectorAll('[data-pv-eagt-tier]');
    var th = Array.prototype.map.call(tiers, function (tier) {
      return (parseFloat(tier.dataset.threshold) || 0) * r;
    });

    root.dataset.cartTotal = String(totalCents);

    Array.prototype.forEach.call(tiers, function (tier, i) {
      tier.classList.toggle('is-unlocked', total >= th[i]);

      if (i < tiers.length - 1) {
        setFill(tier.querySelector('[data-pv-eagt-fill-out]'), Math.min(1, segment(total, th[i], th[i + 1]) * 2));
      }
      if (i > 0) {
        setFill(tier.querySelector('[data-pv-eagt-fill-in]'), Math.max(0, segment(total, th[i - 1], th[i]) * 2 - 1));
      }
    });
  }

  function updateAll(totalCents) {
    document.querySelectorAll(ROOT).forEach(function (root) {
      update(root, totalCents);
    });
  }

  function init(root) {
    if (root.dataset.pvEagtReady) return;
    root.dataset.pvEagtReady = 'true';
    update(root, root.dataset.cartTotal);
  }

  function initAll(scope) {
    (scope || document).querySelectorAll(ROOT).forEach(init);
  }

  if (!window.__pvEagtListening) {
    window.__pvEagtListening = true;

    document.documentElement.addEventListener('cart:refresh', function (e) {
      var cart = e.detail && e.detail.cart;
      if (cart && typeof cart.total_price === 'number') {
        updateAll(cart.total_price);
        return;
      }
      if (!document.querySelector(ROOT)) return;
      fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then(function (res) { return res.json(); })
        .then(function (c) { if (c && typeof c.total_price === 'number') updateAll(c.total_price); })
        .catch(function () { /* keep the last known state */ });
    });

    document.addEventListener('shopify:section:load', function (e) {
      initAll(e.target);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }
})();
